import { useQuery } from "@tanstack/react-query";
import { getAPIFilters } from "PFApp/use_filtered_collection/format_filters";
import {
  fetchSkillsFrameworks,
  SkillsFrameworksResponse
} from "PFCore/services/admin/skills_frameworks/fetch_skills_frameworks";
import { QueryParams } from "PFTypes/query_params";
import { QueryOptions } from "PFTypes/request_options";

import { skillsFrameworksKeys } from "./query_keys";

export const useSkillsFrameworks = (
  params: QueryParams,
  options?: QueryOptions<SkillsFrameworksResponse>
) => {
  const queryKey = skillsFrameworksKeys.list(params);

  return useQuery(
    queryKey,
    () => fetchSkillsFrameworks({ ...params, filters: getAPIFilters(params.filters) }),
    options
  );
};
